import React, {Component} from 'react'
import PropTypes from 'prop-types'
import parseBoxStatistics from "../helpers/parseBoxStatistics"
import StatisticsBySize from "./StatisticsBySize"


class BoxItemStatistics extends Component {
    _parseStatistics = () => {
        const {items} = this.props

        return parseBoxStatistics(items)
    }


    render() {
        const statistics = this._parseStatistics()
        if (!statistics.length) return null

        return (
            <div className="BoxItemStatistics">
                <table className="table">
                    <thead>
                    <tr>
                        <th>Type</th>
                        <th>Total</th>
                        <th>Total by size</th>
                    </tr>
                    </thead>
                    <tbody>
                    {statistics.map(stats => {
                        const {type, total, sizes} = stats

                        return (
                            <tr key={type}>
                                <td>{type}</td>
                                <td>{total}</td>
                                <StatisticsBySize sizes={sizes}/>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        )
    }
}

BoxItemStatistics.propTypes = {
    items: PropTypes.array.isRequired,
}

export default BoxItemStatistics
